(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name aircraftRegistration.controller:ConfirmUnassignRotationDialogCtrl
	 * 
	 * @description
	 * 
	 */
	angular.module('aircraftRegistration').controller(
			'ConfirmUnassignRotationDialogCtrl',
			ConfirmUnassignRotationDialogCtrl);

	function ConfirmUnassignRotationDialogCtrl($uibModalInstance, modalParams,
			EventManagerService) {
		var vm = this;
		vm.ctrlName = 'ConfirmUnassignRotationDialogCtrl';

		vm.model = {
			inaPeriods : modalParams
		};

		vm.onButtonClick = function(flag) {
			$uibModalInstance.close(flag);
		};

		vm.onCloseClick = function() {
			$uibModalInstance.close();
		};
	}
}());
